import { defineComponent, createBlock, openBlock, resolveDynamicComponent, normalizeClass, withCtx, createTextVNode, createElementBlock, createCommentVNode, toDisplayString, createVNode, unref, mergeProps } from 'vue';
import IconClose from './basler-components.es375.js';
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = {
  key: 0,
  class: "tag-list-item__close-icon"
};
const _hoisted_2 = {
  key: 0,
  class: "tag-list-item__close-icon"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TagListItem",
  props: {
    tag: {},
    element: { default: "span" },
    isSmall: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return !props.tag.link ? (openBlock(), createBlock(resolveDynamicComponent(props.element), {
        key: 0,
        class: normalizeClass(["tag-list-item", { "tag-list-item--is-small": props.isSmall }]),
        "data-tag-id": props.tag.id ? props.tag.id : void 0,
        type: props.element === "button" ? "button" : void 0
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(props.tag.text) + " ", 1),
          props.tag.showCloseIcon ? (openBlock(), createElementBlock("span", _hoisted_1, [
            createVNode(unref(IconClose))
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "data-tag-id", "type"])) : (openBlock(), createBlock(_sfc_main$1, mergeProps({
        key: 1,
        class: ["tag-list-item", { "tag-list-item--is-small": props.isSmall }]
      }, props.tag.link), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(props.tag.text) + " ", 1),
          props.tag.showCloseIcon ? (openBlock(), createElementBlock("span", _hoisted_2, [
            createVNode(unref(IconClose))
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["class"]));
    };
  }
});

export { _sfc_main as default };
